import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { useSuperuserGuard } from "@/hooks/use-superuser-guard";
import { Wrench } from "lucide-react";
import { useDeviceAssembly } from "@/hooks/use-device-assembly";
import { AddDeviceCard } from "@/components/assembly/AddDeviceCard";
import { AssemblyTable } from "@/components/assembly/AssemblyTable";

const Assembly = () => {
  useSuperuserGuard();
  const { data: rows = [], isLoading } = useDeviceAssembly();

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-background">
        <AppSidebar />
        <main className="flex-1 p-4 md:p-8 space-y-6">
          <div className="flex items-center gap-3">
            <Wrench className="h-6 w-6" />
            <div>
              <h1 className="text-2xl font-semibold">Assembly</h1>
              <p className="text-sm text-muted-foreground">
                Record serial numbers and quality checks for devices under assembly.
              </p>
            </div>
          </div>
          <AddDeviceCard rows={rows} />
          {isLoading ? (
            <div className="text-sm text-muted-foreground">Loading…</div>
          ) : (
            <AssemblyTable rows={rows} />
          )}
        </main>
      </div>
    </SidebarProvider>
  );
};

export default Assembly;